import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useSelector } from 'react-redux';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const userData = useSelector((state) => state?.posData);
    const vendorId = userData?.id;

    useEffect(() => {
        // REACT_APP_API_ROUTE = "http://localhost:4000/api"
        // Strip "/api" from the end to get the base socket server URL
        const apiRoute = process.env.REACT_APP_API_ROUTE || "http://localhost:4000/api";
        const socketUrl = apiRoute.replace('/api', '');

        // const newSocket = io(socketUrl, {
        //     path: "/api/socket.io",
        //     transports: ['polling', 'websocket'],
        //     reconnection: true,
        //     secure: true,
        //     withCredentials: true,
        // });
        const newSocket = io(socketUrl, {
            path: "/api/socket.io",
            transports: ['polling', 'websocket'],
            reconnection: true,
        });

        setSocket(newSocket);

        newSocket.on('connect', () => {
            console.log('Socket Connected:', newSocket.id);
            if (vendorId) {
                newSocket.emit('join_vendor', vendorId);
                console.log(`Socket joined vendor room: vendor_${vendorId}`);
            }
        });

        newSocket.on('connect_error', (error) => {
            console.error('Socket Connection Error:', error.message);
        });

        newSocket.on('disconnect', (reason) => {
             console.log('Socket Disconnected:', reason);
        });

        return () => {
            newSocket.close();
        };
    }, []);

    // Join room when vendorId becomes available or changes
    useEffect(() => {
        if (socket && socket.connected && vendorId) {
            socket.emit('join_vendor', vendorId);
            console.log(`Socket joined vendor room: vendor_${vendorId}`);
        }
    }, [socket, vendorId]);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
